import { ReactNode } from 'react';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { Link } from '@optimus-web/core';

interface GuideLinkProps {
    text: ReactNode;
}

export const SmsGuideLink = ({ text }: GuideLinkProps) => {
    const url = createGuideLink(ArticlePath.SMSPackageFaq);
    return (
        <Link href={url} target="_blank" rel="noreferrer" inherit>
            {text}
        </Link>
    );
};
